"use strict";

import "bootstrap/js/src/carousel.js";

import processInclude from "base/util";

import * as detailBase from "base/product/detail";
import * as detail from "./product/detail";

$(function () {
    processInclude(detailBase);
    processInclude(detail);
});
